import { createSlice } from "@reduxjs/toolkit";
import { fetchTransactionDetailsThunk } from "../../services/MasterApi";

const initialState = {
    data: null,
    isLoading: false,
    error: null,
};

const transactionDetailsSlice = createSlice({
    name: "transactionDetails",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTransactionDetailsThunk.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.data = null;
            })
            .addCase(fetchTransactionDetailsThunk.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.data = action.payload; // Directly use action.payload
            })
            .addCase(fetchTransactionDetailsThunk.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.data = null;
            });
    }
});

export default transactionDetailsSlice.reducer;
